import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';

import whatsappIcon from "../../../../assets/image/whatsapp-icon.svg";
import logo from "../../../../assets/image/logo.svg";
import { Icon } from "@material-ui/core";

const useStyles = makeStyles({
  list: {
    width: "100%",
    height: "100vh"
  },
  fullList: {
    width: 'auto',
  },
  drawerPaper: {
    width: '100%',
  },
});
const Header = ({history}) => {
  const classes = useStyles();
  const [state, setState] = useState({
    left: false,
  });

  const toggleDrawer = (side, open) => event => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = side => (
    <div
      className={classes.list}
      role="presentation"
      onClick={toggleDrawer(side, false)}
      onKeyDown={toggleDrawer(side, false)}
    >
      <List>
          <ListItem className="d-flex justify-content-between my-3">
            <img src={logo} alt="Beli Bit Coin" className="logo pointer"/>
            <Icon onClick={toggleDrawer('left', false)} className="pointer">menu_open</Icon>
          </ListItem>
          <Divider />
          <ListItem><Link to="/aktivasi-kartu" className="nav-item w-100 my-1">Aktivasi Kartu</Link></ListItem>
          <Divider />
          <ListItem><Link to="/cek-saldo-bitcoin" className="nav-item w-100 my-1">Cek Saldo</Link></ListItem>
          <Divider />
          <ListItem>
            <a href="https://api.whatsapp.com/send?phone=62818550557&text=Saya%20butuh%20bantuan%20Beli%20Bitcoin" target="_blank" rel="noopener noreferrer" 
              className="nav-item w-100 my-1">
              <img src={whatsappIcon} alt="WA" className="img-icon mr-1" />
              Hubungi Kami</a>
          </ListItem>
          <Divider />
      </List>
    </div>
  );
  const goToHome = () => {
    window.location = "https://www.beli-bitcoin.co/";
  }
  return (
      <div className="app-header d-flex justify-content-between">
          
          <div className="app-header__top">
            <img src={logo} alt="Beli Bit Coin" className="logo logo--small pointer" onClick={goToHome}/>
            <div className="flex-row-div align-items-center pointer toggle-drawer" onClick={toggleDrawer('left', true)}>
              <div className="text-xl text-slategrey text-weight-bold mr-3">Menu</div>
              <Icon fontSize="large">menu</Icon>
            </div>
          </div>
          
          <div className="app-header__navigation">
              <Link to="/aktivasi-kartu" className="nav-item">Aktivasi Kartu</Link>
              <Link to="/cek-saldo-bitcoin" className="nav-item">Cek Saldo</Link>
              <a href="https://api.whatsapp.com/send?phone=62818550557&text=Saya%20butuh%20bantuan%20Beli%20Bitcoin" target="_blank" rel="noopener noreferrer" 
                className="nav-item btn-outline-secondary"> 
                <img src={whatsappIcon} alt="WA" className="mr-1 img-icon" /> Hubungi Kami
              </a>
          </div>

          <SwipeableDrawer
            open={state.left}
            classes={{
              paper: classes.drawerPaper,
            }}
            onClose={toggleDrawer('left', false)}
            onOpen={toggleDrawer('left', true)}
          >
            {sideList('left')}
          </SwipeableDrawer>
      </div>
  );
}
export default Header;